import React, { useEffect, useState, useContext } from 'react';

import { useAuth } from '../../contexts/auth2';
import { Navigate,NavLink, useNavigate } from 'react-router-dom';
import AlertMessage from '../../../src/pages/Alert/AlertMessage';
import { ArrowLeft, Save, ChevronRight } from 'lucide-react';
import AsyncSelect from "react-select/async";
import api from '../../api'
import './styles.css';
import { CircleAlert } from 'lucide-react';

const Signup = () => {
    const { signup, signed } = useAuth();
    const [email, setEmail] = useState();
    const [cnpjcpf,setCnpjcpf] = useState();
    const [name, setName] = useState();
    const [password1, setPassword1] = useState();
    const [password2, setPassword2] = useState();
    const [loading, setLoading] = useState(false); // controle do botão

    const [formData, setFormData] = useState({});
    

    const navigate = useNavigate();

    const [alert, setAlert] = useState(null);

    

    const showAlert = (
    type,
    message,
    onConfirm = null,
    okText = 'OK',
    cancelText = 'Cancelar'
  ) => {
    setAlert({
      type,
      message,
      onConfirm,
      okText,
      cancelText,
    });
  };


    const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validação local
    const requiredFields = ["name", "email", "password1", "password2","area_of_activity","number_crm","mobile_phone", "city_id","state_id","address","address_number"];
    const fieldLabels = {
        name: "Nome",
        email: "E-mail",
        password1: "Senha",
        password2: "Confirmar Senha",
        area_of_activity: "Área de atuação",
        number_crm: "Número do CRM",
        mobile_phone: "Número de celular",
        city_id: "Cidade",
        state_id: "Estado",
        address: "Endereço",
        address_number: "Número",
    };
    for (const field of requiredFields) {
    const value = formData[field];
    if (!value || String(value).trim() === "") {
        const label = fieldLabels[field] || field;

        // Para os campos de senha, mensagem genérica
        if (field === "password1" || field === "password2") {
        showAlert("error", `O campo ${label} é obrigatório.`);
        setLoading(false);
        return;
        }

        showAlert("error", `O campo "${label}" é obrigatório.`);
        setLoading(false);
        return;
    }
    }

    if (formData.password1 !== formData.password2) {
        showAlert("error", "As senhas não coincidem.");
        setLoading(false);
        return;
    }

    try {
        const response = await signup(formData);

        // Caso de sucesso
        if (response?.status === 1) {
        navigate("/signup/success");
        return;
        }

        // Caso de erro com status 0 no JSON
        if (response?.status === 0) {
        const firstError =
            response.errors && Object.values(response.errors).flat()[0]
            ? Object.values(response.errors).flat()[0]
            : response.message || "Erro desconhecido";

        showAlert("error", firstError);
        return;
        }

        // fallback genérico
        showAlert("error", response?.message || "Erro ao cadastrar");
    } catch (err) {
        // Se o backend retornou erro de validação 422
        if (err.response?.status === 422) {
        const errors = err.response?.data?.errors;
        const firstError =
            errors && Object.values(errors).flat()[0]
            ? Object.values(errors).flat()[0]
            : err.response?.data?.message || "Erro de validação";

        showAlert("error", firstError);
        return;
        }

        // Outro tipo de erro (500, rede, etc.)
        showAlert("error", "Erro no servidor. Tente novamente.");
        console.error("Erro ao cadastrar:", err);
    } finally {
        setLoading(false);
    }
    };

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    
        
    
    if(!signed){
        return (
            <div className='box-login-nr container'>
            {alert && (
                <AlertMessage
                type={alert.type}               // passa o tipo dinâmico (ex: 'success' ou 'confirm')
                message={alert.message}         // mensagem do alert
                icon={<CircleAlert size={22} color="#101828" />} // 👈 passa o ícone aqui
                onClose={() => setAlert(null)}
                onConfirm={alert.onConfirm}
                okText={alert.okText || "OK"}   // texto padrão OK, mas pode ser personalizado
                cancelText={alert.cancelText || "Cancelar"} // texto padrão Cancelar
                />
            )}

                <NavLink to="/login" style={{display:'flex', margin: '0px 0px 25px 0px'}}><ArrowLeft size={20}/><div style={{margin: "3px 0px 0px 5px"}}>Retornar</div></NavLink>

               

                

                    <div className='subs' style={{display:'flex', justifyContent: 'space-between', margin: '15px 0px 5px 0px'}}>
                    <h1>Cadastrar conta</h1>

                    
                        <button
                        className='btn btn-3'
                        type='submit'
                        disabled={loading}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClick={handleSubmit}
                        >
                            <div style={{ margin: '0px 0px 0px 10px' }}>
                                Criar Conta
                            </div>
                            <ChevronRight size={20} />
                        </button>
                    
                    
                        
                    </div>

                    <div className='subs' style={{margin: '0px 0px 25px 0px',borderBottom: '1px solid #EAECF0', padding: '0px 0px 20px 0px'}}>
                    <p>Preencha os dados nos campos abaixo para acessar o sistema.</p>
                    </div>


                        {/**/}
                        <div className='subs'>
                        <h2>Dados gerais</h2>
                        </div>
                        <div className='boxform' style={{borderBottom: '0', margin: '25px 0px 0px 0px', padding: '0'}}>

                            <div className='boxform-flex' style={{ margin: '0px 40px 0px 0px' }}>

                                <div className='form-input'>
                                    <div className='for-type'>Nome do médico</div>
                                    <div className='for-input'>
                                    <input
                                        type='text'
                                        name='name'
                                        value={formData.name || ''}
                                        onChange={handleChange}
                                        placeholder='Joao'
                                    />
                                    </div>
                                </div>
                                
                                
                            
                            
                            </div>

                            

                            <div className='boxform-flex'>

                                <div className='form-input'>
                                    <div className='for-type'>Número do CRM</div>
                                    <div className='for-input'>
                                    <input
                                        type='text'
                                        name='number_crm'
                                        value={formData.number_crm || ''}
                                        onChange={handleChange}
                                        placeholder='Ex: Dores nas costas'
                                    />
                                    </div>
                                </div>
                            
                            </div>

                            
                        </div>

                        <div className='boxform' style={{margin: '0px 0px 25px 0px', padding: '0px 0px 15px 0px'}}>
                            
                            <div className='boxform-flex'>
                                <div className='form-input'>
                                    <div className='for-type' style={{width: '144px'}}>Área de atuação</div>
                                    <div className='for-input' style={{width: '100%'}}>
                                    <select
                                        name='area_of_activity'
                                        value={formData.area_of_activity || ''}
                                        onChange={handleChange}
                                    >
                                        <option value=''>Selecionar área de atuação</option>
                                        <option value='alergologia'>Alergologia e Imunologia</option>
                                        <option value='anestesiologia'>Anestesiologia</option>
                                        <option value='angiologia'>Angiologia</option>
                                        <option value='cardiologia'>Cardiologia</option>
                                        <option value='cirurgia_geral'>Cirurgia Geral</option>
                                        <option value='cirurgia_plastica'>Cirurgia Plástica</option>
                                        <option value='cirurgia_toracica'>Cirurgia Torácica</option>
                                        <option value='clinica_medica'>Clínica Médica</option>
                                        <option value='dermatologia'>Dermatologia</option>
                                        <option value='endocrinologia'>Endocrinologia e Metabologia</option>
                                        <option value='gastroenterologia'>Gastroenterologia</option>
                                        <option value='geriatria'>Geriatria</option>
                                        <option value='ginecologia'>Ginecologia e Obstetrícia</option>
                                        <option value='hematologia'>Hematologia e Hemoterapia</option>
                                        <option value='infectologia'>Infectologia</option>
                                        <option value='nefrologia'>Nefrologia</option>
                                        <option value='neurologia'>Neurologia</option>
                                        <option value='neurocirurgia'>Neurocirurgia</option>
                                        <option value='oftalmologia'>Oftalmologia</option>
                                        <option value='oncologia'>Oncologia</option>
                                        <option value='ortopedia'>Ortopedia e Traumatologia</option>
                                        <option value='otorrino'>Otorrinolaringologia</option>
                                        <option value='pediatria'>Pediatria</option>
                                        <option value='psiquiatria'>Psiquiatria</option>
                                        <option value='radiologia'>Radiologia e Diagnóstico por Imagem</option>
                                        <option value='reumatologia'>Reumatologia</option>
                                        <option value='urologia'>Urologia</option>
                                
                                    </select>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        

                        <div className='subs'>
                            <h2>Informações de contato</h2>
                        </div>
                        <div className='boxform' >

                            <div className='boxform-flex' style={{ margin: '0px 40px 0px 0px' }}>  

                                <div className='form-input'>
                                    <div className='for-type'>Número de celular</div>
                                    <div className='for-input'>
                                    <input
                                        type='text'
                                        name='mobile_phone'
                                        value={formData.mobile_phone || ''}
                                        onChange={handleChange}
                                        placeholder='91 9 0000 0000'
                                    />
                                    </div>
                                </div>

                                <div className='form-input'>
                                <div className='for-type'>Cidade</div>
                                <div className='for-input'>
                                    <AsyncSelect
                                    cacheOptions
                                    loadOptions={async (inputValue) => {
                                        if (!inputValue) return []; // não busca se nada digitado
                                        try {
                                        const response = await api.get("/city", {
                                            params: { q: inputValue },
                                        });
                                        const data = response.data.data; // array de cidades
                                        return data.map((c) => ({ value: c.id, label: c.name }));
                                        } catch (err) {
                                        console.error("Erro ao buscar cidades:", err);
                                        return [];
                                        }
                                    }}
                                    value={
                                        formData.city_id
                                        ? { value: formData.city_id, label: formData.city_name }
                                        : null
                                    }
                                    onChange={(selected) =>
                                        setFormData((prev) => ({
                                        ...prev,
                                        city_id: selected ? selected.value : "",
                                        city_name: selected ? selected.label : "",
                                        }))
                                    }
                                    placeholder="Buscar cidade..."
                                    isClearable
                                    noOptionsMessage={({ inputValue }) =>
                                        inputValue
                                        ? `Nenhum resultado para "${inputValue}"`
                                        : "Nenhuma cidade encontrada"
                                    }
                                    />
                                </div>
                                </div>

                                <div className='form-input'>
                                    <div className='for-type'>Endereço</div>
                                    <div className='for-input'>
                                    <input
                                        type='text'
                                        name='address'
                                        value={formData.address || ''}
                                        onChange={handleChange}
                                        placeholder='Ex: Av 28 de janeiro N 123'
                                    />
                                    </div>
                                </div>

                            </div>

                            <div className='boxform-flex'>

                                <div className='form-input'>
                                    <div className='for-type'>E-mail</div>
                                    <div className='for-input'>
                                    <input
                                        type='email'
                                        name='email'
                                        value={formData.email || ''}
                                        onChange={handleChange}
                                        placeholder='Ex: joao@gmail.com'
                                    />
                                    </div>
                                </div>

                                <div className='form-input'>
                                    <div className='for-type'>Estado</div>
                                    <div className='for-input'>
                                    <AsyncSelect
                                    cacheOptions
                                    loadOptions={async (inputValue) => {
                                        if (!inputValue) return []; // não busca se nada digitado
                                        try {
                                        const response = await api.get("/state", {
                                            params: { q: inputValue },
                                        });
                                        const data = response.data.data; // array de cidades
                                        return data.map((c) => ({ value: c.id, label: c.name }));
                                        } catch (err) {
                                        console.error("Erro ao buscar cidades:", err);
                                        return [];
                                        }
                                    }}
                                    value={
                                        formData.state_id
                                        ? { value: formData.state_id, label: formData.state_name }
                                        : null
                                    }
                                    onChange={(selected) =>
                                        setFormData((prev) => ({
                                        ...prev,
                                        state_id: selected ? selected.value : "",
                                        state_name: selected ? selected.label : "",
                                        }))
                                    }
                                    placeholder="Buscar estado..."
                                    isClearable
                                    noOptionsMessage={({ inputValue }) =>
                                        inputValue
                                        ? `Nenhum resultado para "${inputValue}"`
                                        : "Nenhuma cidade encontrada"
                                    }
                                    />
                                    </div>
                                </div>

                                <div className='form-input'>
                                    <div className='for-type'>Número</div>
                                    <div className='for-input'>
                                    <input
                                        type='text'
                                        name='address_number'
                                        value={formData.address_number || ''}
                                        onChange={handleChange}
                                        placeholder='1234'
                                    />
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className='subs'>
                            <h2>Senha de acesso</h2>
                        </div>
                        <div className='boxform' >

                            <div className='boxform-flex' style={{ margin: '0px 40px 0px 0px' }}>  
                                <div className='form-input'>
                                    <div className='for-type'>Insira sua senha</div>
                                    <div className='for-input'>
                                    <input
                                        type='password'
                                        name='password1'
                                        value={formData.password1 || ''}
                                        onChange={handleChange}
                                        placeholder='Sua senha'
                                    />
                                    </div>
                                </div>

                            </div>

                            <div className='boxform-flex'>  
                                <div className='form-input'>
                                    <div className='for-type'>Confirmar senha</div>
                                    <div className='for-input'>
                                    <input
                                        type='password'
                                        name='password2'
                                        value={formData.password2 || ''}
                                        onChange={handleChange}
                                        placeholder='Repitir senha'
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/** */}




            
            
        </div>
        );
    }else{
        return <Navigate to="/dashboard" />;
    }
}
export default Signup;